import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { handleUnauthorized } from "../../utils/apiHelper";
import SuccessAlert from "./../child/Alert/SuccessAlert";
import DengerAlert from "./../child/Alert/DengerAlert";
import Loader from "./../child/Loder";

const AddFAQPageNew = () => {
  const [loading, setLoading] = useState(false);
  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState("");
  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();
  const { id } = useParams();
  const isEditMode = !!id;
  const authToken = localStorage.getItem("authToken");

  useEffect(() => {
    if (!isEditMode) return;

    const fetchSetting = async () => {
      setLoading(true);
      try {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/admin/faqById/${id}`, {
          method: "GET",
          headers: { Authorization: `Bearer ${authToken}` },
        });

        if (response.status === 401) {
          handleUnauthorized(navigate);
          return;
        }

        const data = await response.json();
        if (response.ok) {
          setQuestion(data.result.question || "");
          setAnswer(data.result.answer || "");

        } else {
          setErrorMessage("Error fetching FAQs");
          clearMessage();
        }
      } catch (error) {
        setErrorMessage("Error fetching FAQs");
        clearMessage();
      } finally {
        setLoading(false);
      }
    };

    fetchSetting();
  }, [id, navigate]);

  // Function to clear messages
  const clearMessage = () => {
    setTimeout(() => {
      setSuccessMessage("");
      setErrorMessage("");
    }, 3000);
  };

  // Validate inputs
  const validateInputs = () => {
    const newErrors = {};
    if (!question) newErrors.question = "Question is required";
    if (!answer) newErrors.answer = "Answer is required";

    if (question) {
      const hasAlphabet = /[A-Za-z]/;

      if (!hasAlphabet.test(question)) {
        newErrors.question = "Question can not be only numbers or only special characters";
      }
      if (question.length < 3) {
        newErrors.question = "Question must be at least 3 characters long";
      }
      if (answer) {
        const hasAlphabet = /[A-Za-z]/;

        if (!hasAlphabet.test(answer)) {
          newErrors.description = "Answer can not be only numbers or only special characters";
        }
        if (answer.length < 5) {
          newErrors.answer = "Answer must be at least 5 characters long";
        }
      }

    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    if (!validateInputs()) {
      setLoading(false);
      return;
    }

    try {
      const method = isEditMode ? "PUT" : "POST";
      const API_ENDPOINT = `${process.env.REACT_APP_BASE_URL}/admin/${isEditMode ? `faqUpdate/${id}` : "faqAdd"}`;

      const response = await fetch(API_ENDPOINT, {
        method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify({ question, answer, status: "active" }),
      });

      const data = await response.json();
      if (response.ok) {
        if(data.message == 'This FAQ already exists.')
        {
          setErrorMessage(data.message);
          clearMessage();
        }
        else
        {
          setSuccessMessage(data.message || (isEditMode ? "FAQ Updated" : "FAQ Added"));
          clearMessage();
           setTimeout(() => navigate("/faq"), 3000);

        }


      } else {
        setErrorMessage(data.message);
        clearMessage();
      }
    } catch (error) {
      setErrorMessage(error?.message || "Something went wrong");
      clearMessage();
    } finally {
      setLoading(false);
    }
  };

  // Show loader when loading
  if (loading) return <Loader />;

  return (
    <div className="row gy-4">
      <div className="col-lg-12">
        <div className="card">
          <div className="card-header">
            {/* <h5 className="card-title mb-0">{isEditMode ? "Edit FAQ" : "Add FAQ"}</h5> */}
          </div>
          <div className="card-body">
            {successMessage && <SuccessAlert message={successMessage} />}
            {errorMessage && <DengerAlert message={errorMessage} />}
            <form className="row gy-3 needs-validation" noValidate onSubmit={handleSubmit}>
              <div className="col-md-12">
                <label className="form-label">Question<span className="text-danger-600">*</span></label>
                <input
                  type="text"
                  className={`form-control ${errors.question ? "is-invalid" : ""}`}
                  id="question"
                  placeholder="Enter question"
                  value={question}
                    maxLength={64}
                  onChange={(e) => {
                    setQuestion(e.target.value);
                    setErrors((prev) => ({ ...prev, question: "" }));
                  }}
                  onInput={(e) => {
                    e.target.value = e.target.value
                      .replace(/\s{2,}/g, " ") // Replace multiple spaces with a single space
                      .trimStart(); // Prevent leading spaces
                  }}
                />
                {errors.question && <p className="text-danger mt-1">{errors.question}</p>}
              </div>

              <div className="col-md-12">
                <label className="form-label">Answer<span className="text-danger-600">*</span></label>
                <textarea
                  type="text"
                  className={`form-control ${errors.answer ? "is-invalid" : ""}`}
                  id="answer"
                  cols="4"
                  rows="5"
                  placeholder="Enter answer"
                  value={answer}
                  maxLength={300}
                  onChange={(e) => {
                    setAnswer(e.target.value);
                    setErrors((prev) => ({ ...prev, answer: "" }));
                  }}
                  onInput={(e) => {
                    e.target.value = e.target.value
                      .replace(/\s{2,}/g, " ") // Replace multiple spaces with a single space
                      .trimStart(); // Prevent leading spaces
                  }}
                />
                {errors.answer && <p className="text-danger mt-1">{errors.answer}</p>}
              </div>

              <div className="col-12">
                <button className="btn btn-primary mt-3 float-end" type="submit" disabled={loading}>
                  {loading ? "Saving..." : "Save"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddFAQPageNew;
